import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Mutation, ApolloConsumer } from 'react-apollo'
import gql from 'graphql-tag'
import {
  Header,
  Button,
  Modal,
  Form,
  Input,
  Tab,
  Dropdown,
} from 'semantic-ui-react'

import { CONDITIONS_QUERY } from '../List'
import { SUGGESTED_CONDITIONS_QUERY } from './'

class ConfirmModal extends Component {
  state = {
    name: '',
    info: '',
    existingConditionId: '',
    searchQuery: '',
    conditions: [],
  }

  panes = [
    {
      menuItem: 'Confirm New Condition',
      render: () => (
        <div style={{ marginTop: 16 }}>
          <Modal.Content>
            <Modal.Description>
              <Header as="h3">{this.props.condition.name}</Header>
              <p>Are you sure you want to confirm this condition suggestion?</p>
              {this.renderNewForm()}
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Mutation
              mutation={APPROVE_CONDITION}
              update={cache => {
                const variables = { limit: 50, offset: 0 }
                const { suggestedConditions } = cache.readQuery({
                  query: SUGGESTED_CONDITIONS_QUERY,
                  variables,
                })

                cache.writeQuery({
                  query: SUGGESTED_CONDITIONS_QUERY,
                  variables,
                  data: {
                    suggestedConditions: suggestedConditions.filter(
                      cond => cond.id !== this.props.condition.id,
                    ),
                  },
                })
              }}
            >
              {approveCondition => {
                const { name, info } = this.state
                return (
                  <Button
                    positive
                    disabled={this.disableConfirm()}
                    onClick={async () => {
                      await approveCondition({
                        variables: {
                          input: {
                            name,
                            info,
                            id: this.props.condition.id,
                          },
                        },
                      })
                      this.props.history.push('/conditions')
                    }}
                  >
                    Yes, Confirm Request
                  </Button>
                )
              }}
            </Mutation>
          </Modal.Actions>
        </div>
      ),
    },
    {
      menuItem: 'Choose Existing Condition',
      render: () => (
        <div style={{ marginTop: 16 }}>
          <Modal.Content>
            <Modal.Description>
              <Header as="h3">{this.props.condition.name}</Header>
              <p>
                Select an existing condition to associated with this suggested
                condition.
              </p>
              {this.renderExistingForm()}
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Mutation
              mutation={APPROVE_EXISTING_CONDITION}
              refetchQueries={[
                {
                  query: SUGGESTED_CONDITIONS_QUERY,
                  variables: {
                    limit: 50,
                    offset: 0,
                  },
                },
              ]}
            >
              {approveCondition => {
                const { existingConditionId } = this.state
                return (
                  <Button
                    positive
                    disabled={!existingConditionId}
                    onClick={async () => {
                      await approveCondition({
                        variables: {
                          input: {
                            existingConditionId,
                            id: this.props.condition.id,
                          },
                        },
                      })
                      this.props.history.push('/conditions')
                    }}
                  >
                    Yes, Confirm Request
                  </Button>
                )
              }}
            </Mutation>
          </Modal.Actions>
        </div>
      ),
    },
  ]

  componentDidMount = () => {
    if (this.props.condition) {
      this.setState({ name: this.props.condition.name })
    }
  }

  disableConfirm = () => {
    let { name, info } = this.state
    return !(name && info)
  }

  handleChange = event =>
    this.setState({ [event.target.name]: event.target.value })

  handleDropdownChange = (e, { value }) =>
    this.setState({ searchQuery: '', existingConditionId: value })

  renderNewForm() {
    const { name, info } = this.state

    return (
      <Form>
        <Form.Field
          name="name"
          control={Input}
          label="Condition name"
          placeholder="Condition name"
          onChange={this.handleChange}
          value={name}
        />
        <Form.Field
          name="info"
          control={Input}
          label="Condition info"
          placeholder="Condition info"
          onChange={this.handleChange}
          value={info}
        />
      </Form>
    )
  }

  renderExistingForm() {
    const { existingConditionId, searchQuery, conditions } = this.state

    return (
      <Form>
        <ApolloConsumer>
          {client => {
            return (
              <Dropdown
                fluid
                onChange={this.handleDropdownChange}
                onSearchChange={async (e, { searchQuery }) => {
                  const { data } = await client.query({
                    query: CONDITIONS_QUERY,
                    variables: {
                      limit: 20,
                      query: searchQuery,
                    },
                  })
                  this.setState({
                    searchQuery,
                    conditions: data.conditions.map(cond => ({
                      key: cond.id,
                      value: cond.id,
                      text: cond.name,
                    })),
                  })
                }}
                options={conditions}
                placeholder="Existing condition"
                search
                searchQuery={searchQuery}
                selection
                value={existingConditionId}
              />
            )
          }}
        </ApolloConsumer>
      </Form>
    )
  }

  render() {
    return (
      <Modal
        size="small"
        style={{
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: 100,
          height: 540,
        }}
        trigger={<Button positive>Confirm</Button>}
      >
        <div style={{ padding: 32 }}>
          <Tab panes={this.panes} />
        </div>
      </Modal>
    )
  }
}

const APPROVE_CONDITION = gql`
  mutation ApproveCondition($input: CreateConditionArgs!) {
    approveCondition(input: $input) {
      id
      name
      info
    }
  }
`

const APPROVE_EXISTING_CONDITION = gql`
  mutation ApproveCondition($input: CreateConditionArgs!) {
    approveCondition(input: $input) {
      id
    }
  }
`

export default withRouter(ConfirmModal)
